<template>
  <div
    :class="{ 'room-zhiyun-version': versionConfig.ZHIYUN_VERSION }"
    style="position:relative;"
  >
    <div class="serach">
      <a-form layout="inline" class="left" :form="form">
        <a-form-item label="开始">
          <a-date-picker
            style="width:115px"
            @change="changeStartDate"
            :allowClear="false"
            v-decorator="[
              'startDate',
              {
                rules: [{ required: true, message: '请选择开始日期' }],
                initialValue: initialStartValue
              }
            ]"
          />
        </a-form-item>
        <a-form-item label="结束">
          <a-date-picker
            :disabledDate="disabledEndDate"
            :allowClear="false"
            @change="getRoomData"
            style="width:115px"
            v-decorator="[
              'endDate',
              {
                rules: [{ required: true, message: '请选择结束日期' }],
                initialValue: initialEndValue
              }
            ]"
          />
        </a-form-item>
        <a-form-item label="房型">
          <a-select
            v-decorator="['roomType']"
            style="width: 120px"
            allowClear
            @change="onSearch"
          >
            <a-select-option
              v-for="(item, index) in availableRooms"
              :value="item.Id"
              :key="index"
              >{{ item.Text }}</a-select-option
            >
          </a-select>
        </a-form-item>
      </a-form>
      <div class="right">
        房号：<input
          class="js_roomNo txt"
          style="width:80px"
          value=""
          placeholder="房号"
          @input="onSearch"
        />
        姓名：<input
          class="js_roomName txt"
          style="width:80px"
          value=""
          placeholder="姓名"
          @input="onSearch"
        />
        关键字：<a-popover
          title="订单列表"
          :visible="visibleOrder"
          placement="bottomLeft"
        >
          <div slot="content" class="order-data" ref="orderBox">
            <ul>
              <li v-for="item in orderList" :key="item.Id">
                <p>
                  <label> 客户</label>： {{ item.Name }}
                  <small v-if="item.ChannelName"
                    >| {{ item.ChannelName }}</small
                  >
                  <span>
                    <a-tag
                      :color="
                        item.Status == '预订'
                          ? '#2db7f5'
                          : item.Status == '完成'
                          ? '#87d068'
                          : item.Status == '取消'
                          ? '#f50'
                          : '#0dc3ba'
                      "
                      >{{ item.Status }}</a-tag
                    >
                  </span>
                </p>
                <p v-if="item.Phone"><label>电话</label>：{{ item.Phone }}</p>
                <p>
                  <label>入离时间</label>：<small>
                    {{ item.CheckInDate }} | {{ item.CheckOutDate }}</small
                  >
                </p>
                <p>
                  <label>订单号</label>：<span
                    class="pop-order-no"
                    @click="orderDetail(item.Id, true)"
                    >{{ item.OrderNo }}</span
                  >
                </p>
                <p v-if="item.ChannelOrderNo">
                  <label>渠道单号</label>：
                  {{ item.ChannelOrderNo }}
                </p>
              </li>
            </ul>
            <div class="page" v-if="total > PageSize">
              <a-button type="link" :disabled="disabledPrev" @click="prev"
                ><a-icon type="left"
              /></a-button>
              <a-button type="link" :disabled="disabledNext" @click="next"
                ><a-icon type="right"
              /></a-button>
            </div>
          </div>
          <input
            ref="keyword"
            class="js_keyword txt"
            style="width:213px"
            value=""
            placeholder="订单号/姓名/手机号/房号/备注"
            @focus="handleFocus"
            @keyup="searchOrder"
            @enter="onSearch"
          />
        </a-popover>
        <a-button type="primary" html-type="submit" @click="handleSearch"
          >查询</a-button
        >
        <a-button type="primary" style="margin-left:3px" @click="resetSearch"
          >重置</a-button
        >
        <a-button
          style="margin-left:3px"
          type="primary"
          :loading="readLoading"
          @click="readCard"
          >读卡</a-button
        >
      </div>
      <span class="show-price">
        <span style="margin-right:5px">
          按楼层:
          <a-checkbox v-model="sortModel" @change="getRoomData"> </a-checkbox
        ></span>
        显示房价 <a-switch @change="onShowPrice" />
        <a-dropdown>
          <a
            style="font-size:12px;"
            class="ant-dropdown-link"
            @click="e => e.preventDefault()"
          >
            更多 <a-icon type="down" />
          </a>
          <a-menu slot="overlay" style="padding:15px; border: 1px solid #ddd;">
            <a-menu-item key="0">
              <a-checkbox @change="changeRepairStatus"
                >显示已维修/封房记录
              </a-checkbox>
            </a-menu-item>
            <a-menu-item key="1">
              <a-button
                style="margin-left:5px"
                type="primary"
                @click="$router.push({ name: 'RoomService' })"
                v-if="defaultItem.RoomCleanFlow == 1"
                >房务管理</a-button
              >
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </div>
    <a-spin :spinning="loading">
      <div id="forward">
        <!-- 头部日历 -->
        <div class="main-header" ref="mainHeader">
          <table>
            <tr>
              <td class="slider-td"></td>
              <td class="slider-td"></td>
              <td v-for="(item, index) in calendarOutput" :key="index">
                <h4
                  :class="{
                    isWeekend: item.DayOfWeek == '6' || item.DayOfWeek == '0',
                    istoday: isAccountDate(item.FullDate)
                  }"
                >
                  {{ isAccountDate(item.FullDate) ? "今天" : item.Date }}
                  {{ item.Week.charAt(item.Week.length - 1) }}
                  <br />
                  <span
                    :class="{
                      'room-number': true,
                      over:
                        availableQuantityObj &&
                        availableQuantityObj[item.FullDate]
                          ? Number(
                              availableQuantityObj[item.FullDate]
                                .AvailableQuantity || 0
                            ) <= 0
                          : Number(item.AvailableQuantity) <= 0
                    }"
                    >{{ availableRoom(item) }}</span
                  >
                </h4>
              </td>
            </tr>
          </table>
        </div>
        <!-- end头部日历 -->
        <!-- 房间信息 -->
        <div
          class="main-content"
          ref="mainContent"
          @scroll="mainScroll"
          @mouseenter="forwardMouseenter('main')"
        >
          <table>
            <tr v-for="(item, index) in data" :key="index">
              <td class="slider-td"></td>
              <td class="slider-td"></td>
              <td v-for="(dItem, dIndex) in calendarOutput" :key="dIndex">
                <!-- 空房状态 -->
                <div
                  :class="{
                    empty: true,
                    shiftLeft: defaultItem.isShowTime
                  }"
                  :data-date="dItem.FullDate"
                  :data-no="item.No"
                  :data-roomid="item.Id"
                  :data-roomname="item.RoomTypeName"
                  :data-roomTypeId="item.RoomTypeId"
                  @mouseenter="emptyMouseenter(index, dIndex)"
                  @mouseleave="emptyMouseleave(index, dIndex)"
                  @click="emptyChecked($event, index, dIndex, item)"
                >
                  <a-icon type="check-circle" />
                  <template v-for="(pItem, pIndex) in priceData">
                    <div
                      class="price"
                      v-if="
                        isShowPrice &&
                          pItem.Date == dItem.FullDate &&
                          pItem.RoomTypeId === item.RoomTypeId
                      "
                      :key="pIndex"
                    >
                      {{ pItem.Price }}
                    </div>
                  </template>
                </div>
                <!--end 空房状态 -->
                <draggable
                  class="dragArea"
                  draggable=".drag-item"
                  :forceFallback="true"
                  :list="item.roomStatusCalendar"
                  :data-date="dItem.FullDate"
                  :data-roomid="item.Id"
                  :data-roomname="item.RoomTypeName"
                  :data-no="item.No"
                  tag="div"
                  :group="{ name: 'g1' }"
                  :move="getdata"
                  @end="datadragEnd"
                  @dragover="allowDrop"
                >
                  <template v-for="(rItem, rIndex) in item.roomStatusCalendar">
                    <!-- 按天模式可拖动换房 -->
                    <template
                      v-if="
                        rItem.FullDate === dItem.FullDate &&
                          (rItem.RoomStatus === 2 || rItem.RoomStatus === 3) &&
                          rItem.isShowInfo
                      "
                    >
                      <a-popover
                        :key="rIndex"
                        placement="bottomLeft"
                        trigger="hover"
                      >
                        <template slot="content">
                          <p>
                            开始日期：{{
                              moment(rItem.RepairBeginTime).format(
                                "YYYY-MM-DD HH:mm"
                              )
                            }}
                          </p>
                          <p>
                            结束日期：{{
                              moment(rItem.RepairEndTime).format(
                                "YYYY-MM-DD HH:mm"
                              )
                            }}
                          </p>
                          <p v-if="rItem.RepairReason">
                            原因：{{ rItem.RepairReason }}
                          </p>
                          <p v-if="rItem.RepairRemark">
                            备注：{{ rItem.RepairRemark }}
                          </p>
                        </template>
                        <template slot="title">
                          <span>{{ item.No }}{{ item.RoomTypeName }}</span>
                        </template>
                        <div
                          class="room-item"
                          :style="rItem.styleOption"
                          @mouseenter="emptyMouseenter(index, dIndex)"
                          @mouseleave="emptyMouseleave(index, dIndex)"
                        >
                          <div
                            v-if="rItem.RoomStatus === 2"
                            style="height:100%"
                          >
                            <a-popconfirm
                              title="确定解除维修吗?"
                              @confirm="setRepairEndWithDate(item, rItem)"
                              okText="确定"
                              cancelText="取消"
                              v-if="rItem.RepairStatusName == '维修中'"
                            >
                              <div class="repair-txt">
                                {{ rItem.RepairStatusName }}
                                <div class="repair-section">
                                  <span
                                    v-if="rItem.RepairReason"
                                    :class="{ hasRemark: rItem.RepairRemark }"
                                  >
                                    原因: {{ rItem.RepairReason }}</span
                                  >
                                  <span v-if="rItem.RepairRemark">
                                    备注: {{ rItem.RepairRemark }}</span
                                  >
                                </div>
                              </div>
                            </a-popconfirm>
                            <div class="repair-txt repair-complete" v-else>
                              {{ rItem.RepairStatusName }}
                              <div class="repair-section">
                                <span
                                  v-if="rItem.RepairReason"
                                  :class="{ hasRemark: rItem.RepairRemark }"
                                >
                                  原因: {{ rItem.RepairReason }}</span
                                >
                                <span v-if="rItem.RepairRemark">
                                  备注: {{ rItem.RepairRemark }}</span
                                >
                              </div>
                            </div>
                          </div>
                          <div
                            v-else-if="rItem.RoomStatus === 3"
                            style="height:100%"
                          >
                            <a-popconfirm
                              title="确定解除封房吗?"
                              @confirm="cancelLock(item, rItem)"
                              okText="确定"
                              cancelText="取消"
                              v-if="rItem.RepairStatusName == '封房中'"
                            >
                              <div class="repair-txt">
                                {{ rItem.RepairStatusName }}
                                <div class="repair-section">
                                  <span
                                    v-if="rItem.RepairReason"
                                    :class="{ hasRemark: rItem.RepairRemark }"
                                  >
                                    原因: {{ rItem.RepairReason }}</span
                                  >
                                  <span v-if="rItem.RepairRemark">
                                    备注: {{ rItem.RepairRemark }}</span
                                  >
                                </div>
                              </div>
                            </a-popconfirm>
                            <div class="repair-txt repair-complete" v-else>
                              {{ rItem.RepairStatusName }}
                              <div class="repair-section">
                                <span
                                  v-if="rItem.RepairReason"
                                  :class="{ hasRemark: rItem.RepairRemark }"
                                >
                                  原因: {{ rItem.RepairReason }}</span
                                >
                                <span v-if="rItem.RepairRemark">
                                  备注: {{ rItem.RepairRemark }}</span
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </a-popover>
                    </template>
                    <template
                      v-for="(gItem, gIndex) in rItem.CalendarGuestDetails"
                    >
                      <a-popover
                        placement="bottom"
                        trigger="hover"
                        :mouseLeaveDelay="0.01"
                        :key="gIndex"
                        v-if="
                          rItem.FullDate === dItem.FullDate && gItem.isShowInfo
                        "
                      >
                        <template slot="content">
                          <div
                            v-if="
                              (gItem.Status == 2 || gItem.Status == 3) &&
                                rItem.AllCalendarGuestDetails &&
                                rItem.AllCalendarGuestDetails.length > 1
                            "
                            class="all-order-items"
                          >
                            <div
                              v-for="(guest,
                              guestIndex) in rItem.AllCalendarGuestDetails"
                              :key="guest.OrderId"
                            >
                              <h4
                                style="background:#f6f6f6;margin-top:5px;padding:0 5px;font-weight:bold"
                              >
                                订单{{ guestIndex + 1 }}
                              </h4>
                              <OrderInfo
                                :info="guest"
                                :defaultItem="defaultItem"
                                :roomInfo="item"
                              ></OrderInfo>
                            </div>
                          </div>
                          <div v-else>
                            <OrderInfo
                              :info="gItem"
                              :defaultItem="defaultItem"
                              :roomInfo="item"
                            ></OrderInfo>
                          </div>
                        </template>
                        <template slot="title">
                          <span>{{ item.RoomTypeName }}【{{ item.No }}】</span>
                        </template>
                        <div
                          :class="{
                            'room-item': true,
                            'drag-item':
                              !defaultItem.isShowTime && gItem.OrderStatus === 0
                          }"
                          :data-detailId="gItem.OrderDetailId"
                          :data-status="gItem.OrderStatus"
                          :data-roomname="item.RoomTypeName"
                          :data-no="item.No"
                          :data-date="gItem.CheckInDate"
                          :data-day="
                            moment(gItem.CheckOutDate).diff(
                              moment(gItem.CheckInDate),
                              'days'
                            )
                          "
                          :style="gItem.styleOption"
                          @mouseenter="emptyMouseenter(index, dIndex)"
                          @mouseleave="emptyMouseleave(index, dIndex)"
                        >
                          <div class="inner" @mouseup="editInfo(gItem, rItem)">
                            <div style="overflow: hidden;white-space: nowrap;">
                              {{ gItem.GuestName }}
                              <img
                                :class="{
                                  'contact-icon': true,
                                  dn: !gItem.HasContacted
                                }"
                                :src="contactIcon"
                              />
                              <a-icon
                                style="margin-left: 2px;position: absolute;top: 4px;right: 3px;"
                                v-if="gItem.IsHourRoom"
                                type="clock-circle"
                              />
                              <span
                                class="is-checking is-status-checking"
                                v-if="gItem.IsChecking"
                                >查</span
                              >
                            </div>
                            <div class="tag-sec">
                              <span class="card" v-if="gItem.MemberCardNo">{{
                                defaultItem.Member ? defaultItem.Member : "卡"
                              }}</span>
                              <span
                                class="customer"
                                v-if="gItem.CustomerName"
                                >{{
                                  defaultItem.Customer
                                    ? defaultItem.Customer
                                    : "客"
                                }}</span
                              >
                              <span class="chanel" v-if="gItem.ChanelName">{{
                                defaultItem.Channel
                                  ? defaultItem.Channel
                                  : gItem.ChanelName.slice(0, 1)
                              }}</span>
                            </div>
                            <div class="sign-icon">
                              <i
                                class="iconfont icon-xingxing"
                                v-if="gItem.IsImportant"
                              ></i>
                              <i
                                class="iconfont icon-plane"
                                v-if="gItem.IsPlane"
                              ></i>
                              <i
                                class="iconfont icon-bus"
                                v-if="gItem.IsBus"
                              ></i>
                              <span v-if="gItem.IsMeeting">会</span>
                            </div>
                          </div>
                        </div>
                      </a-popover>
                    </template>
                  </template>
                </draggable>
              </td>
            </tr>
          </table>
        </div>
        <!-- end 房间信息 -->
        <!-- 左侧栏房型房号 -->
        <div class="fixed-left">
          <div class="fixed-header">
            <table>
              <tr>
                <td class="room-type-cls">
                  房型
                </td>
                <td>房号</td>
              </tr>
            </table>
          </div>
          <div class="outer-container">
            <div
              class="fixed-content scroll-hidden-y"
              ref="fixedContent"
              @mouseenter="forwardMouseenter('fixed')"
              @scroll="fixedScroll"
            >
              <table>
                <tr v-for="(item, index) in data" :key="index">
                  <td
                    class="room-type-cls"
                    :rowspan="item.count"
                    v-if="item.count"
                  >
                    <a-popover
                      placement="right"
                      v-if="item.RoomTypeDescription"
                    >
                      <template slot="content">
                        <div class="desc-sec">
                          {{ item.RoomTypeDescription }}
                        </div>
                      </template>
                      <span style="font-weight: bold;">{{
                        item.RoomTypeName
                      }}</span>
                    </a-popover>
                    <span style="font-weight: bold;" v-else>{{
                      item.RoomTypeName
                    }}</span>
                  </td>
                  <td
                    class="room-no"
                    @mouseenter="roomNoMouseenter"
                    @mouseleave="roomNoMouseleave"
                    @click="editRoomStatus(item)"
                  >
                    <div
                      class="room-inner"
                      :style="{ backgroundColor: item.Color }"
                    >
                      <span class="status" v-if="item.RoomCleanStatus === 0">
                        {{ item.RoomCleanStatus === 0 ? "脏" : "" }}
                      </span>
                      <a-popover
                        placement="right"
                        v-if="item.Remark || item.FloorName"
                      >
                        <template slot="content">
                          <div class="desc-sec">
                            <p>楼层：{{ item.FloorName }}</p>
                            <p>备注：{{ item.Remark }}</p>
                          </div>
                        </template>
                        <span style="display:block;font-weight: bold;">
                          {{ item.No }}</span
                        >
                      </a-popover>
                      <span style="font-weight: bold;" v-else>
                        {{ item.No }}</span
                      >
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <!-- end左侧栏房型房号 -->
        <span @click="fold" class="arrow-icon"><a-icon type="caret-up"/></span>
      </div>
    </a-spin>
    <a-row class="btm-box">
      <a-col :span="16" class="status-section dn">
        <span
          v-for="(item, index) in roomStatusColor"
          :key="index"
          class="status-lable"
          ><i
            :style="{ backgroundColor: item.Data.Color }"
            class="status-icon"
          ></i
          >{{ item.Text }} {{ item.count }}</span
        >
      </a-col>
      <a-col :span="8" class="btn-section fixed-btm">
        <div
          v-show="isEmptyRoomCheck"
          id="js_btn"
          v-if="defaultItem.PlusHotelOrderModel != 1"
        >
          <a-button type="primary" @click="orderRoom('order')">预订</a-button>
          <a-button
            type="primary"
            id="js_checkinBtn"
            @click="orderRoom('checkin')"
            >入住</a-button
          >
          <a-button type="primary" @click="clearCheckArray">取消选中</a-button>
        </div>
        <a-button
          type="primary"
          @click="quickOrder('checkin')"
          v-if="defaultItem.PlusHotelOrderModel == 1"
          :disabled="!isShowQuickCheckInBtn"
          >快速入住</a-button
        >
        <a-button
          type="primary"
          @click="quickOrder('order')"
          v-if="defaultItem.PlusHotelOrderModel == 1"
          >预订房间</a-button
        >
        <a-button
          type="primary"
          @click="clearCheckArray"
          v-if="defaultItem.PlusHotelOrderModel == 1 && checkedDateArray.length"
          >取消选中</a-button
        >
      </a-col>
    </a-row>
    <span
      class="wallet-btn"
      @click="openQuickAccount"
      title="快速记账管理"
      v-if="defaultItem.QuickAccountManagement == 1"
    >
      <img src="@/assets/images/wallet.png" alt=""
    /></span>

    <span class="hour-btn" @click="getOverTimeHourRoom"
      >超时<br />钟点房<em v-if="hourCount > 0">{{ hourCount }}</em></span
    >
    <span class="schedule-btn" @click="openRoomList"
      >未排房<em v-if="unscheduledCount > 0">{{ unscheduledCount }}</em></span
    >
    <a-drawer
      title="未排房列表"
      placement="right"
      width="500px"
      :closable="true"
      @close="onClose"
      :visible="visible"
    >
      <data-grid
        ref="dataGrid"
        :columns="columns"
        api="Order_UnscheduledList"
        v-model="gridData"
        :params="params"
        :pagination="true"
        bordered
      >
      </data-grid>
    </a-drawer>
    <a-drawer
      title="超时钟点房列表"
      placement="right"
      width="500px"
      :closable="true"
      @close="visibleHourRoom = false"
      :visible="visibleHourRoom"
    >
      <data-grid
        ref="hourRoomGrid"
        :columns="hourColumns"
        api="GetOverTimeHourRoom"
        v-model="hourData"
        :pagination="false"
        dataField="Data"
        rowKey="key"
        :onLoad="onLoadHourData"
        bordered
      >
      </data-grid>
    </a-drawer>
    <a-modal
      title="选择操作员"
      :destroyOnClose="true"
      v-model="visibleOperator"
      @ok="submitOperator"
      @cancel="visibleOperator = false"
      okText="确定"
      cancelText="取消"
      :maskClosable="false"
    >
      <data-form
        ref="operatorForm"
        :data="operatorFormData"
        :content="operatorContent"
        :labelCol="4"
        :colnum="2"
      >
      </data-form>
    </a-modal>
    <QuickAccount ref="QuickAccount"></QuickAccount>
  </div>
</template>

<script>
import "./room.less";
import { DataForm } from "@/components/dataForm";
import contactIcon from "@/assets/images/contact.png";
import { DataGrid } from "@/components/dataGrid";
import { cache } from "@/utils/common";
import {
  OrderDetailModal,
  TeamOrderDetailModal
} from "@/views/orderManage/funtion.js";
import {
  RoomUpdateModal,
  RoomOrderModal,
  TeamRoomOrderModal
} from "./index.js";
import moment from "moment";
moment.locale("zh-cn");
import draggable from "vuedraggable";
import QuickAccount from "./QuickAccount";
import OrderInfo from "./roomstatus/OrderInfo.vue";
import SelectOrderModal from "./roomstatus/";
import cloneDeep from "lodash/cloneDeep";
import { debounce } from "lodash";
if (versionConfig.ZHIYUN_VERSION) {
  import("./roomZhiyun.less");
}
export default {
  components: {
    draggable,
    DataGrid,
    DataForm,
    QuickAccount,
    OrderInfo
  },
  data() {
    return {
      versionConfig,
      roomNumber: "",
      contactIcon,
      open: false,
      mouseType: "",
      defaultDateValue: [],
      data: [],
      form: this.$form.createForm(this),
      calendarOutput: [],
      // isShowQuickCheckInBtn: true,
      isEmptyRoomCheck: false,
      roomStatusColor: [],
      availableRooms: [],
      user: null,
      confirmLoading: false,
      checkedDateArray: [], //选中日期数组
      roomOptions: {},
      isShowPrice: false,
      priceData: [],
      roomColorCountObj: {},
      defaultItem: {},
      isDrag: false,
      isFold: false,
      visible: false,
      gridData: [],
      params: {
        Status: null
      },
      visibleHourRoom: false,
      hourData: [],
      hourCount: 0,
      hourColumns: [
        {
          title: "房号",
          dataIndex: "RoomNo",
          width: 90,
          customRender: (text, record) => {
            if (text) {
              const orderDetail = {
                click: () => {
                  this.orderDetail(record.Id);
                }
              };
              return (
                <a-button type="link" size="small" {...{ on: orderDetail }}>
                  {text}
                </a-button>
              );
            }
          }
        },
        {
          title: "客人姓名",
          width: 100,
          dataIndex: "GuestName"
        },
        {
          title: "离店时间",
          width: 150,
          dataIndex: "CheckOutTime"
        },
        {
          title: "超时时间(分钟)",
          dataIndex: "OverMinutes"
        }
      ],
      columns: [
        {
          title: "订单号",
          dataIndex: "OrderNo",
          width: 70,
          customRender: (text, record) => {
            if (text) {
              const orderDetail = {
                click: () => {
                  this.orderDetail(record.Id);
                }
              };
              return (
                <a-button type="link" size="small" {...{ on: orderDetail }}>
                  {text}
                </a-button>
              );
            }
          }
        },
        {
          title: "住店日期",
          width: 100,
          dataIndex: "CheckInDate"
        },
        {
          title: "离店日期",
          width: 100,
          dataIndex: "CheckOutDate"
        },
        {
          title: "姓名",
          width: 80,
          dataIndex: "Name"
        },
        {
          title: "渠道",
          dataIndex: "ChannelName"
        }
      ],
      readLoading: false,
      initialEndValue: null,
      initialStartValue: null,
      loading: false,
      roomNos: [],
      orderList: [],
      visibleOrder: false,
      PageIndex: 0,
      PageSize: 10,
      disabledNext: false,
      disabledPrev: true,
      total: 0,
      visibleOperator: false,
      operatorFormData: {},
      OperatorId: "",
      OperatorName: "",
      curPitem: null,
      curItem: null,
      operatorContent: [],
      isShowRepaired: false,
      unscheduledCount: 0,
      sortModel: false,
      baseData: [],
      availableQuantityObj: null
    };
  },
  created() {
    this.isDrag = false;
    this.user = cache.get("user");
    this.getDefaultItem().then(() => {
      this.getSelectData().then(() => {
        this.getRoomData();
      });
    });
    const _this = this;
    this.$nextTick(() => {
      document.addEventListener("click", e => {
        if (_this.$refs.orderBox) {
          if (
            !_this.$refs.orderBox.contains(e.target) &&
            !_this.$refs.keyword.contains(e.target)
          ) {
            _this.visibleOrder = false;
          }
        }
      });
    });
  },
  mounted() {
    this.calcHeight(0);
  },
  computed: {
    isAccountDate() {
      return function(val) {
        return val == moment(this.user.AccountDate).format("YYYY-MM-DD");
      };
    },
    availableRoom() {
      return function(item) {
        // const num = Number(val);
        const { availableQuantityObj } = this;
        const num =
          availableQuantityObj && availableQuantityObj[item.FullDate]
            ? availableQuantityObj[item.FullDate].AvailableQuantity || 0
            : item.AvailableQuantity;
        if (num >= 0) {
          return "剩" + num;
        } else {
          return "超订" + Math.abs(num);
        }
      };
    },
    isShowQuickCheckInBtn() {
      return (
        !this.checkedDateArray.length ||
        this.checkedDateArray.every(item =>
          moment(item.date[0], "YYYY-MM-DD").isSameOrBefore(
            this.user.AccountDate
          )
        )
      );
    }
  },
  methods: {
    next() {
      this.PageIndex++;
      this.disabledNext =
        this.PageIndex == Math.ceil(this.total / this.PageSize) - 1;
      this.disabledPrev = false;
      const keyWords = document.querySelector(".js_keyword").value;
      this.searchData(keyWords);
    },
    prev() {
      if (this.PageIndex) {
        this.PageIndex--;
      }
      this.disabledNext = false;
      this.disabledPrev = this.PageIndex == 0;
      const keyWords = document.querySelector(".js_keyword").value;
      this.searchData(keyWords);
    },
    searchOrder(e) {
      const value = e.target.value;
      if (value && value.length > 1) {
        this.searchData(value);
      } else {
        this.visibleOrder = false;
      }
    },
    searchData(value) {
      this.$post("Order_List", {
        Keyword: value.trim(),
        PageIndex: this.PageIndex,
        PageSize: this.PageSize
      }).then(res => {
        this.orderList = res.Data.Datas;
        this.total = res.Data.Total;
        if (this.orderList.length) {
          this.visibleOrder = true;
        } else {
          this.visibleOrder = false;
        }
      });
    },
    handleFocus() {
      this.PageIndex = 0;
      this.disabledPrev = true;
      this.disabledNext = false;
      const keyWords = document.querySelector(".js_keyword").value;
      if (keyWords && keyWords.length > 1) {
        this.searchData(keyWords);
      }
    },
    ////获取系统参数值
    getDefaultItem() {
      return new Promise(resolve => {
        this.$post("Room_GetDefaultTime", {}).then(res => {
          this.defaultItem = {
            PriceCodeId: res.Data.PriceCodeId,
            isShowTime: res.Data.RoomStatusModel == "0",
            IsIndependentPriceCode: res.Data.IsIndependentPriceCode,
            IsHoldTotalPrice: res.Data.IsHoldTotalPrice,
            ...res.Data.CustomCircleSign
          };
          this.defaultItem.PreAuthorizeItems = res.Data.PreAuthorizeItems;
          res.Data.DoorlockConfigList.forEach(item => {
            this.defaultItem[item.Code] = item.Value;
          });
          res.Data.SystemConstList.forEach(item => {
            this.defaultItem[item.Code] = item.Value;
          });
          res.Data.TimeList.forEach(item => {
            if (item.Code == "ArrivalsTime" || item.Code == "DepartureTime") {
              this.defaultItem[item.Code] = item.Value;
            }
          });
          const minusDay = this.defaultItem.isShowTime ? 1 : 2;
          this.initialStartValue = moment(this.user.AccountDate).subtract(
            minusDay,
            "d"
          );
          const addDays =
            this.defaultItem.FutureRoomStatusDays > 0
              ? this.defaultItem.FutureRoomStatusDays
              : 7;
          this.initialEndValue = moment(this.initialStartValue).add(
            addDays,
            "day"
          );
          // this.getRoomData();
          if (this.defaultItem.PlusHotelOrderModel == 1) {
            this.fold();
          }
          resolve(res);
        });
      });
    },
    getUnscheduledCount() {
      this.$post("Order_UnscheduledList", {
        PageIndex: 0,
        PageSize: 1
      }).then(res => {
        this.unscheduledCount = res.Data.Total;
      });
      this.$post("GetOverTimeHourRoom", {}).then(res => {
        this.hourCount = res.Data.length;
      });
    },
    onLoadHourData(res) {
      if (res.Data && res.Data.length) {
        res.Data.forEach((el, index) => {
          el.key = index;
        });
      }
      return res;
    },
    //结束时间选择范围
    disabledEndDate(endValue) {
      const fields = this.form.getFieldsValue();
      return endValue && endValue < fields["startDate"].startOf("day");
    },
    changeStartDate(value) {
      this.form.setFieldsValue({
        endDate: moment(value).add(1, "months")
      });
      this.getRoomData();
    },
    changeRepairStatus(e) {
      this.isShowRepaired = e.target.checked;
      this.getRoomData();
    },
    //获取房态信息
    getRoomData() {
      this.$nextTick(() => {
        this.clearCheckArray();
        this.form.validateFields((err, fieldsValue) => {
          if (err) {
            this.loading = false;
            return;
          }
          this.loading = true;
          // const fields = this.form.getFieldsValue();
          // const roomNo = document.querySelector(".js_roomNo").value;
          // const keyWords = document.querySelector(".js_keyword").value;
          let params = {
            StartDate: fieldsValue["startDate"].format("YYYY-MM-DD"),
            EndDate: fieldsValue["endDate"].format("YYYY-MM-DD"),
            // RoomTypeId: fieldsValue.roomType,
            // RoomNo: roomNo && roomNo.trim(),
            // KeyWords: keyWords && keyWords.trim(),
            SortModel: this.sortModel ? 1 : 0
          };
          if (this.isShowRepaired) {
            params.IsShowRepaired = this.isShowRepaired;
          }
          this.$post("Room_List", params)
            .then(res => {
              const data = res.Data.RoomNoStatuses;
              this.calendarOutput = res.Data.CalendarOutput;
              data.forEach(element => {
                element.roomStatusCalendar = element.RoomStatusCalendarOutputs.map(
                  v => {
                    let fullDate = v.FullDate;
                    if (v.RoomStatus === 2 || v.RoomStatus === 3) {
                      //维修状态
                      this.showDetail(
                        v,
                        v.RepairBeginTime,
                        v.RepairEndTime,
                        fullDate
                      );
                    } else {
                      v.AllCalendarGuestDetails = cloneDeep(
                        v.CalendarGuestDetails
                      );
                      if (
                        !this.defaultItem.isShowTime &&
                        v.CalendarGuestDetails &&
                        v.CalendarGuestDetails.length > 1
                      ) {
                        v.CalendarGuestDetails = [v.CalendarGuestDetails[0]];
                      }
                      v.CalendarGuestDetails.map(item => {
                        let startTime = item.CheckInTime;
                        let endTime = item.CheckOutTime;
                        if (!this.defaultItem.isShowTime) {
                          startTime = item.CheckInDate;
                          endTime = item.CheckOutDate;
                          // startTime = moment(startTime).format("YYYY-MM-DD");
                          // endTime = moment(endTime).format("YYYY-MM-DD");
                        }
                        this.showDetail(item, startTime, endTime, fullDate);
                      });
                    }
                    return v;
                  }
                );
              });
              this.roomColorCountObj = res.Data.TodayRoomStatusCount;
              // this.getRoomStatusColor();
              this.roomStatusColor.map(v => {
                if (this.roomColorCountObj[v.Code] !== undefined) {
                  v.count = this.roomColorCountObj[v.Code];
                }
              });
              this.loading = false;
              this.baseData = cloneDeep(data);
              // this.baseData = cloneDeep(this.data);
              const roomNo = document.querySelector(".js_roomNo").value;
              const guestName = document.querySelector(".js_roomName").value;
              const fields = this.form.getFieldsValue();
              const roomType = fields.roomType;
              if (!roomNo && !roomType && !guestName) {
                this.availableQuantityObj = null;
                this.data = data;
                this.setRoomData();
                return;
              }
              this.onSearch();
            })
            .catch(() => {
              this.loading = false;
            });
        });
      });
      this.getUnscheduledCount();
    },
    setRoomData() {
      var result = [];
      let count = 0;
      // this.data.sort((a, b) => a.RoomTypeId - b.RoomTypeId);
      this.data.forEach((el, index) => {
        var arr = [result[result.length - 1]];
        if (!index) {
          count = 1;
          result.push(el);
          el.count = count;
        } else if (el.RoomTypeId === arr[0].RoomTypeId) {
          count++;
          if (index == this.data.length - 1) {
            this.data[index - count + 1].count = count;
          }
        } else {
          this.data[index - count].count = count;
          count = 1;
          el.count = count;
          result.push(el);
        }
      });
      this.roomNos = this.data.map(el => {
        return {
          Id: el.Id,
          No: el.No,
          RoomStatus: el.RoomStatus
        };
      });
    },
    showDetail(item, startTime, endTime, fullDate) {
      let startDate = moment(startTime).format("YYYY-MM-DD");
      let endDate = moment(endTime).format("YYYY-MM-DD");
      let endDateTime = endTime;
      if (!this.defaultItem.isShowTime && startDate == endDate) {
        endDateTime = moment(endDate)
          .add(1, "d")
          .format("YYYY-MM-DD");
      }
      let hours = moment(endDateTime).diff(moment(startTime), "hours");
      let sep = Math.ceil(hours / 24) - 1;
      let styleOption = {
        backgroundColor: item.CustomColor ? item.CustomColor : item.Color
      };
      item.styleOption = styleOption;
      if (startDate === fullDate && hours > 0) {
        let startHour = moment(startTime).hour();
        item.styleOption.left = (startHour / 24) * 100 + "%";
        item.styleOption.width =
          "calc(" + (hours / 24) * 100 + "% + " + sep + "px)";
        item.isShowInfo = true;
      } else if (moment(fullDate).isAfter(startDate)) {
        hours = moment(endDateTime).diff(moment(fullDate), "hours");
        if (hours > 0) {
          sep = Math.ceil(hours / 24) - 1;
          item.styleOption.left = 0;
          item.styleOption.width =
            "calc(" + (hours / 24) * 100 + "% + " + sep + "px)";
          item.isShowInfo = true;
        } else {
          item.isShowInfo = false;
        }
      } else {
        item.isShowInfo = false;
      }
    },
    //获取下拉数据
    getSelectData() {
      return new Promise(resolve => {
        this.$post("Common_GetSelect", {
          Types: "roomtype,RoomStatusColor,operater"
        }).then(res => {
          this.availableRooms = res.Data.roomtype;
          this.roomStatusColor = res.Data.RoomStatusColor;
          this.operatorContent = [
            {
              label: "操作员",
              name: "OperatorId",
              colnum: 2,
              type: "select",
              data: res.Data.operater,
              option: {
                rules: [{ required: true, message: "请选择操作员" }]
              },
              onChange: (val, sel) => {
                this.OperatorId = val;
                this.OperatorName = sel.Text;
              }
            }
          ];
          // });
          resolve(res);
        });
      });
    },
    // 搜索
    handleSearch(e) {
      e.preventDefault();
      this.getRoomData();
      this.onShowPrice(this.isShowPrice);
    },
    resetSearch(e) {
      this.form.resetFields();
      if (document.querySelector(".js_roomNo")) {
        document.querySelector(".js_roomNo").value = "";
      }
      if (document.querySelector(".js_roomName")) {
        document.querySelector(".js_roomName").value = "";
      }
      if (document.querySelector(".js_keyword")) {
        document.querySelector(".js_keyword").value = "";
      }

      this.handleSearch(e);
    },
    // 显示房价
    onShowPrice(value) {
      if (value) {
        const fields = this.form.getFieldsValue();
        const roomNo = document.querySelector(".js_roomNo").value;
        this.$post("Room_GetPrice", {
          CheckInDate: fields["startDate"].format("YYYY-MM-DD"),
          CheckOutDate: fields["endDate"].format("YYYY-MM-DD"),
          RoomTypeId: fields.roomType,
          RoomNo: roomNo && roomNo.trim()
        }).then(res => {
          this.priceData = res.Data;
        });
        this.isShowPrice = true;
      } else {
        this.isShowPrice = false;
      }
    },
    // 获取房间状态色值
    // getRoomStatusColor() {
    //   this.$post("Common_GetSelect", { Types: "RoomStatusColor" }).then(res => {
    //     this.roomStatusColor = res.Data.RoomStatusColor;
    //     this.roomStatusColor.map(v => {
    //       if (this.roomColorCountObj[v.Code] !== undefined) {
    //         v.count = this.roomColorCountObj[v.Code];
    //       }
    //     });
    //   });
    // },
    // 编辑房间状态
    editRoomStatus(item) {
      if (item.ColorExplain == "停用") {
        return false;
      }
      RoomUpdateModal({
        option: item,
        roomNos: this.roomNos,
        defaultItem: this.defaultItem,
        update: () => {
          this.getRoomData();
        }
      });
    },
    submitOperator() {
      const roomForm = this.$refs.operatorForm.form;
      roomForm.validateFields(err => {
        if (!err) {
          this.submitRepair(this.curPitem, this.curItem);
        }
      });
    },
    //解除时间段内的维修
    setRepairEndWithDate(pItem, item) {
      if (this.defaultItem.ChooseHandler == "1") {
        this.visibleOperator = true;
        // this.visiblePop = false;
        this.curPitem = pItem;
        this.curItem = item;
      } else {
        this.submitRepair(pItem, item);
      }
    },
    cancelLock(pItem, item) {
      const json = {
        RoomId: [pItem.Id],
        RoomNo: [pItem.No],
        RepairBeginTime: moment(item.RepairBeginTime).format("YYYY-MM-DD"),
        RepairEndTime: moment(item.RepairEndTime).format("YYYY-MM-DD"),
        HandlerId: this.user.OperatorId,
        HandlerName: this.user.OperatorName
      };
      const _this = this;
      this.$post("SetLockEnd", json).then(res => {
        this.$message.success("操作成功");
        this.$info({
          title: "解除封房",
          content: res.Message,
          onOk() {
            _this.getRoomData();
          }
        });
      });
    },
    submitRepair(pItem, item) {
      this.OperatorId = this.OperatorId
        ? this.OperatorId
        : this.user.OperatorId;
      this.OperatorName = this.OperatorName
        ? this.OperatorName
        : this.user.OperatorName;
      const params = {
        RoomId: [pItem.Id],
        RoomNo: [pItem.No],
        SetDirty: true,
        RepairBeginTime: moment(item.RepairBeginTime).format("YYYY-MM-DD"),
        RepairEndTime: moment(item.RepairEndTime).format("YYYY-MM-DD"),
        HandlerId: this.OperatorId,
        HandlerName: this.OperatorName
      };
      const _this = this;
      this.$post("Room_SetRepair_End", params).then(() => {
        this.$info({
          title: "解除维修",
          content: "已完成" + pItem.No + "的维修作业，请及时安排人员清洁卫生",
          onOk() {
            _this.getRoomData();
            _this.visibleOperator = false;
          }
        });
      });
    },
    quickOrder(type) {
      if (this.checkedDateArray && this.checkedDateArray.length) {
        this.checkedDateArray.sort((a, b) => a.roomTypeId - b.roomTypeId);

        if (type == "order") {
          this.checkedDateArray.sort(
            (a, b) => moment(a.date[0]).valueOf() - moment(b.date[0]).valueOf()
          );
          this.checkedDateArray.sort(
            (a, b) =>
              moment(a.date[a.date.length - 1]).valueOf() -
              moment(b.date[b.date.length - 1]).valueOf()
          );
          let list = [];
          this.checkedDateArray.forEach((el, index) => {
            el.roomInfo = [{ RoomId: el.roomId, RoomNo: el.roomNo }];
            var last = list[list.length - 1];
            if (!index) {
              list.push(el);
            } else if (
              last &&
              last.roomTypeId == el.roomTypeId &&
              last.date[0] == el.date[0] &&
              last.date[last.date.length - 1] == el.date[el.date.length - 1]
            ) {
              last.roomInfo.push({
                RoomId: el.roomId,
                RoomNo: el.roomNo
              });
            } else {
              list.push(el);
            }
          });
          this.orderRoom("order", list);
        } else if (type == "checkin" && this.isShowQuickCheckInBtn) {
          this.orderRoom("checkin", this.checkedDateArray);
        }
      } else {
        const roomOptions = {
          roomInfoData: []
        };
        if (type != "checkin") {
          const dateFormat = this.defaultItem.isShowTime
            ? "YYYY-MM-DD HH:mm"
            : "YYYY-MM-DD";
          const startDate = moment(
            this.user.AccountDate + " " + this.defaultItem.ArrivalsTime,
            dateFormat
          );
          let end = moment(this.user.AccountDate)
            .add(1, "d")
            .format("YYYY-MM-DD");
          const endDate = moment(
            end + " " + this.defaultItem.DepartureTime,
            dateFormat
          );
          roomOptions.roomInfoData.push({
            CheckInTime: startDate,
            CheckOutTime: endDate,
            OriginCheckInTime: startDate,
            OriginCheckOutTime: endDate,
            InTime: this.defaultItem.ArrivalsTime,
            OutTime: this.defaultItem.DepartureTime,
            RoomId: "",
            RoomNo: "",
            RoomTypeId: "",
            RoomTypeName: "",
            PriceStructureId: "",
            PeopleNum: 0,
            BasePeopleNum: 0,
            BaseBookingRoomNum: 0,
            BaseRoomNum: 0,
            BookingRoomNum: 0,
            RoomNum: 0,
            RoomCount: 0,
            Persons: [],
            IDCardCount: 0,
            AppointAddRoomNos: [],
            TransactionPrices: [],
            SelectRoomNos: [],
            // BaseSelectRoomNos: [],
            BaseTransactionPrices: [],
            RoomPrice: "",
            OrderStatus: 0,
            DayStatus:
              this.defaultItem.RoomPriceInputModel == "0" ? "每日" : "总价",
            Hovered: false
          });
        }

        TeamRoomOrderModal({
          actionType: type,
          defaultItem: this.defaultItem,
          options: roomOptions,
          update: () => {
            this.getRoomData();
          }
        });
      }
    },
    //预定或者开房
    orderRoom(type, teamOrderData) {
      let data = teamOrderData ? teamOrderData : this.checkedDateArray;
      this.roomOptions.roomInfoData = [];
      data.forEach(element => {
        const dateFormat = this.defaultItem.isShowTime
          ? "YYYY-MM-DD HH:mm"
          : "YYYY-MM-DD";
        let startDate = null;
        const now = moment(this.user.AccountDate).format("YYYY-MM-DD");
        const isBeforeToday = moment(element.date[0], "YYYY-MM-DD").isBefore(
          now
        );
        let inTime = this.defaultItem.ArrivalsTime;
        if (type == "checkin") {
          if (isBeforeToday) {
            //补录订单开房时取选中日期加默认预抵
            startDate = moment(
              element.date[0] + " " + this.defaultItem.ArrivalsTime,
              dateFormat
            );
          } else {
            //正常开房时账务日期等于自然日期时，取账务日期加自然日期时间，
            //不等的情况下取账务日期加默认预抵时间
            const hour =
              now == moment().format("YYYY-MM-DD")
                ? moment().format("HH:mm")
                : this.defaultItem.ArrivalsTime;
            inTime = hour;
            startDate = moment(now + " " + hour, dateFormat);
          }
        } else {
          startDate = moment(
            element.date[0] + " " + this.defaultItem.ArrivalsTime,
            dateFormat
          );
        }
        let end =
          element.date.length &&
          moment(element.date[element.date.length - 1])
            .add(1, "d")
            .format("YYYY-MM-DD");
        const endDate = moment(
          end + " " + this.defaultItem.DepartureTime,
          dateFormat
        );
        const params = {
          CheckInTime: startDate,
          CheckOutTime: endDate,
          RoomTypeId: element.roomTypeId
        };
        if (teamOrderData) {
          params.AppointAddRoomNos = element.roomInfo ? element.roomInfo : [];
          params.RoomNum = element.roomInfo ? element.roomInfo.length : 0;
          params.PeopleNum = element.roomInfo ? element.roomInfo.length : 0;
          params.BookingRoomNum = params.RoomNum;
          params.BaseBookingRoomNum = params.RoomNum;
          params.BaseRoomNum = params.RoomNum;
          params.BasePeopleNum = params.PeopleNum;
          params.MinPeopleNum = params.PeopleNum;
          params.RoomCount = 0;
          params.SelectRoomNos = params.AppointAddRoomNos.map(v => v.RoomNo);
          // params.BaseSelectRoomNos = [];
        }
        this.roomOptions.roomInfoData.push({
          ...params,
          OriginCheckInTime: params.CheckInTime,
          OriginCheckOutTime: params.CheckOutTime,
          InTime: inTime,
          OutTime: this.defaultItem.DepartureTime,
          RoomId: element.roomId,
          RoomNo: element.roomNo,
          RoomTypeId: element.roomTypeId,
          RoomTypeName: element.roomTypeName,
          PriceStructureId: "",
          Persons: [],
          IDCardCount: 0,
          TransactionPrices: [],
          BaseTransactionPrices: [],
          RoomPrice: "",
          OrderStatus: type == "checkin" ? 1 : 0,
          DayStatus:
            this.defaultItem.RoomPriceInputModel == "0" ? "每日" : "总价",
          Hovered: false
        });
      });
      if (teamOrderData) {
        TeamRoomOrderModal({
          actionType: type,
          defaultItem: this.defaultItem,
          options: this.roomOptions,
          update: () => {
            this.getRoomData();
          }
        });
      } else {
        const url = type == "order" ? "Order_Add" : "Order_OpenRoom";
        RoomOrderModal({
          actionType: type,
          submitApi: url,
          defaultItem: this.defaultItem,
          options: this.roomOptions,
          update: () => {
            this.getRoomData();
          }
        });
      }
    },
    //空房选中
    emptyChecked(e, rowIndex, columnIndex, item) {
      let now = moment(this.user.AccountDate).format("YYYY-MM-DD");
      // 如果小于今天的日期或者停用房型，则不可预订和开房
      const isBefore = moment(
        e.currentTarget.dataset.date,
        "YYYY-MM-DD"
      ).isBefore(now);
      const attributes = this.defaultItem.RoomControlAttr;
      const canCheck = (attributes | 16) == attributes || !isBefore;
      if (item.ColorExplain == "停用" || !canCheck) {
        return;
      }
      if (this.$common.hasClass(e.currentTarget, "room-checked")) {
        this.$common.removeClass(e.currentTarget, "room-checked");
      } else {
        this.$common.addClass(e.currentTarget, "room-checked");
      }
      let roomCheckedObj = (this.$refs.mainContent || {}).querySelectorAll(
        ".room-checked"
      );
      let roomCheckedArr = [...(roomCheckedObj || [])];
      var result = [];
      roomCheckedArr.forEach(function(v, i) {
        const now = v.dataset.date;
        const typeId = v.dataset.roomtypeid;
        const roomname = v.dataset.roomname;
        const roomId = v.dataset.roomid;
        const roomNo = v.dataset.no;
        var temp = result[result.length - 1] && result[result.length - 1].date;
        const prevDate = i >= 1 ? roomCheckedArr[i - 1].dataset.date : now;
        const obj = {
          date: [now],
          roomId: roomId,
          roomNo: roomNo,
          roomTypeId: typeId,
          roomTypeName: roomname
        };
        if (!i) {
          result.push(obj);
        } else if (
          moment(prevDate)
            .add(1, "d")
            .format("YYYY-MM-DD") === now &&
          result[result.length - 1].roomId === roomId
        ) {
          temp.push(now);
        } else {
          result.push(obj);
        }
      });
      this.checkedDateArray = result;
      const btnGroup = document.getElementById("js_btn");
      const flag = this.checkedDateArray.every(item => {
        return (
          item.date[0] == now ||
          moment(item.date[0], "YYYY-MM-DD").isBefore(now)
        );
      });
      if (btnGroup && roomCheckedObj) {
        btnGroup.style = roomCheckedObj.length
          ? "display:block"
          : "display:none";
      }

      const checkInBtn = document.getElementById("js_checkinBtn");
      if (checkInBtn) {
        checkInBtn.style = flag ? "display:inline-block;" : "display:none";
      }
    },
    collectionRoom() {},
    roomNoMouseenter(e) {
      this.$common.addClass(e.currentTarget, "hovered");
    },
    roomNoMouseleave(e) {
      this.$common.removeClass(e.currentTarget, "hovered");
    },
    emptyMouseenter(rowIndex, columnIndex) {
      let headerTd = this.$refs.mainHeader.querySelectorAll("td")[
        columnIndex + 2
      ];
      let fixedTd = this.$refs.fixedContent.querySelectorAll("tr")[rowIndex];
      this.$common.addClass(headerTd, "active");
      this.$common.addClass(fixedTd, "active");
    },
    emptyMouseleave(rowIndex, columnIndex) {
      let headerTd = this.$refs.mainHeader.querySelectorAll("td")[
        columnIndex + 2
      ];
      let fixedTd = this.$refs.fixedContent.querySelectorAll("tr")[rowIndex];
      this.$common.removeClass(headerTd, "active");
      this.$common.removeClass(fixedTd, "active");
    },
    fixedScroll(e) {
      if (this.mouseType == "fixed") {
        this.$refs.mainContent.scrollTop = e.currentTarget.scrollTop;
      }
    },
    mainScroll(e) {
      if (this.mouseType == "main") {
        this.$refs.fixedContent.scrollTop = e.currentTarget.scrollTop;
        this.$refs.mainHeader.scrollLeft = e.currentTarget.scrollLeft;
      }
    },
    forwardMouseenter(type) {
      this.mouseType = type;
    },
    clearCheckArray() {
      this.checkedDateArray = [];
      this.isEmptyRoomCheck = false;
      const btnGroup = document.getElementById("js_btn");
      if (btnGroup) {
        btnGroup.style = "display:none";
      }
      this.$nextTick(() => {
        const array = this.$refs.mainContent.querySelectorAll(".room-checked");
        for (let i = 0; i < array.length; i++) {
          this.$common.removeClass(array[i], "room-checked");
        }
      });
    },
    //编辑房间信息
    editInfo(record, rItem) {
      if (
        (record.Status == 2 || record.Status == 3) &&
        rItem.AllCalendarGuestDetails &&
        rItem.AllCalendarGuestDetails.length > 1
      ) {
        SelectOrderModal({
          orderList: rItem.AllCalendarGuestDetails,
          defaultItem: this.defaultItem,
          submit: info => {
            this.viewOrderInfo(info);
          }
        });
      } else {
        this.viewOrderInfo(record);
      }
    },
    viewOrderInfo(record) {
      this.visibleOrder = false;
      if (this.isDrag) {
        return false;
      }
      const data = {
        ...record,
        ChannelName: record.ChanelName,
        ContactRemark: record.Remark
      };
      if (this.defaultItem.PlusHotelOrderModel == 1) {
        TeamOrderDetailModal({
          actionType: "update",
          option: data,
          orderId: record.OrderId,
          update: () => {
            this.getRoomData();
          }
        });
      } else {
        OrderDetailModal({
          actionType: "update",
          option: data,
          orderId: record.OrderId,
          update: () => {
            this.getRoomData();
          }
        });
      }
    },
    //拖动中与拖动结束
    getdata() {
      this.isDrag = true;
    },
    datadragEnd(evt) {
      const _this = this;
      if (this.isDrag) {
        const fromRoomno = evt.from.children[0].dataset.no;
        const fromRoomname = evt.from.children[0].dataset.roomname;
        const fromDate = evt.from.children[0].dataset.date;
        const toRoomno = evt.to.dataset.no;
        const toRoomname = evt.to.dataset.roomname;
        const toDate = evt.to.dataset.date;
        if (
          fromRoomno == toRoomno &&
          fromRoomname == toRoomname &&
          fromDate == toDate
        ) {
          this.isDrag = false;
          return;
        }
        const h = this.$createElement;
        this.$confirm({
          title: "确定执行拖动操作吗？",
          content: h("div", {}, [
            h(
              "p",
              { style: "margin-top: 25px;" },
              fromDate + "预入的【" + fromRoomname + "-" + fromRoomno + "】"
            ),
            h(
              "p",
              {
                style: "font-size: 20px; color: #f4a300; padding-left: 100px;"
              },
              [h("a-icon", { props: { type: "arrow-down", size: 20 } })]
            ),
            h("p", toDate + "预入的【" + toRoomname + "-" + toRoomno + "】?")
          ]),
          onOk() {
            _this.loading = true;
            const detailId = evt.from.children[0].dataset.detailid;
            const days = evt.from.children[0].dataset.day;
            const toStartDate = evt.to.dataset.date;
            const endDate = moment(toStartDate)
              .add(days, "d")
              .format("YYYY-MM-DD");
            const TargetRoomId = evt.to.dataset.roomid;
            const json = {
              OrderDetailId: detailId,
              CheckInTime: toStartDate + " " + _this.defaultItem.ArrivalsTime,
              CheckOutTime: endDate + " " + _this.defaultItem.DepartureTime,
              TargetRoomId: TargetRoomId
            };
            _this
              .$post("Order_MoveOrderDetail", json)
              .then(() => {
                _this.getRoomData();
                _this.$message.success("操作成功！");
                _this.isDrag = false;
              })
              .catch(() => {
                _this.isDrag = false;
                _this.getRoomData();
              });
          },
          onCancel() {
            _this.isDrag = false;
          }
        });
      }
    },
    allowDrop: function() {
      // ev.preventDefault();
      this.isDrag = false;
    },
    fold() {
      const btm = document.querySelector(".status-section");
      const btn = document.querySelector(".btn-section");
      if (this.isFold) {
        this.$common.addClass(btm, "dn");
        this.$common.addClass(btn, "fixed-btm");
        this.calcHeight(0);
        this.isFold = false;
      } else {
        this.$common.removeClass(btm, "dn");
        this.$common.removeClass(btn, "fixed-btm");
        const btmH = btm.clientHeight;
        this.calcHeight(btmH);
        this.isFold = true;
      }
    },
    calcHeight(minusH) {
      const deg = minusH > 0 ? "180deg" : 0;
      const forwardH = document.documentElement.clientHeight - 177 - minusH;
      const forward = document.getElementById("forward");
      const content = document.querySelector(".main-content");
      const left = document.querySelector(".fixed-content");
      const arrow = document.querySelector(".arrow-icon i");
      forward.style.height = forwardH + "px";
      content.style.height = forwardH - 60 + "px";
      left.style.height = forwardH - 68 + "px";
      arrow.style.transform = "rotateX(" + deg + ")";
    },
    onClose() {
      this.visible = false;
    },
    openRoomList() {
      this.visible = true;
      this.$refs.dataGrid && this.$refs.dataGrid.reload();
    },
    openQuickAccount() {
      this.$refs.QuickAccount.show();
    },
    getOverTimeHourRoom() {
      this.visibleHourRoom = true;
      this.$refs.hourRoomGrid && this.$refs.hourRoomGrid.reload();
    },
    //查看详情
    orderDetail(Id, status, roomInfoId) {
      this.visibleOrder = false;
      if (this.defaultItem.PlusHotelOrderModel == 1) {
        TeamOrderDetailModal({
          orderId: Id,
          roomInfoId: roomInfoId,
          update: () => {
            if (this.visible && this.$refs.dataGrid) {
              this.$refs.dataGrid.reload();
            }
            if (this.visibleHourRoom && this.$refs.hourRoomGrid) {
              this.$refs.hourRoomGrid.reload();
            }
            if (!status) {
              this.getRoomData();
            }
          }
        });
      } else {
        OrderDetailModal({
          orderId: Id,
          update: () => {
            if (this.visible && this.$refs.dataGrid) {
              this.$refs.dataGrid.reload();
            }
            if (this.visibleHourRoom && this.$refs.hourRoomGrid) {
              this.$refs.hourRoomGrid.reload();
            }
            if (!status) {
              this.getRoomData();
            }
          }
        });
      }
    },
    readCard() {
      let url = "";
      this.readLoading = true;
      if (isNaN(this.defaultItem.LocalServicePort)) {
        url = this.defaultItem.LocalServicePort;
      } else {
        url =
          "http://localhost:" +
          this.defaultItem.LocalServicePort +
          "/Lock/Read";
      }
      this.$post(url)
        .then(res => {
          const data = res.Data || {};
          let json = {};
          if (data.UsePhysicalId && data.PhysicalId) {
            json.PhysicalCardNo = data.PhysicalId;
          } else {
            json.CardId = data.CardId;
          }
          if ((json.CardId && json.CardId != 0) || json.PhysicalCardNo) {
            this.$post("Card_LockRead", json)
              .then(res => {
                this.orderDetail(res.Data.OrderId, false, res.Data.RoomInfoId);
                this.readLoading = false;
              })
              .catch(() => {
                this.readLoading = false;
              });
          } else {
            this.$message.error("此卡为空卡，请查询订单制卡!");
            this.readLoading = false;
          }
        })
        .catch(() => {
          // this.$message.error("读卡失败，请重试!");
          this.readLoading = false;
        });
    },
    onSearch: debounce(function() {
      const roomNo = document.querySelector(".js_roomNo").value;
      const guestName = document.querySelector(".js_roomName").value;
      const fields = this.form.getFieldsValue();
      const roomType = fields.roomType;
      const data = cloneDeep(this.baseData);
      if (!roomNo && !roomType && !guestName) {
        this.data = data;
        this.countAvailableQuantity();
        return;
      }
      let list = [],
        ids = [];
      data.forEach(el => {
        let isPush = true;
        if (roomType && el.RoomTypeId != roomType) {
          isPush = false;
        }
        if (roomNo && !el.No.includes(roomNo)) {
          isPush = false;
        }
        if (
          isPush &&
          guestName &&
          el.roomStatusCalendar &&
          el.roomStatusCalendar.length
        ) {
          for (let i = 0; i < el.roomStatusCalendar.length; i++) {
            const item = el.roomStatusCalendar[i];
            (item.CalendarGuestDetails || []).forEach(p => {
              if (p.isShowInfo) {
                if (
                  guestName &&
                  (p.GuestName || "").includes(guestName) &&
                  !ids.includes(el.Id)
                ) {
                  list.push(el);
                  ids.push(el.Id);
                }
              }
            });
          }
        } else if (!guestName && isPush) {
          list.push(el);
          ids.push(el.Id);
        }
      });
      (list || []).sort((a, b) => a.RoomTypeSort - b.RoomTypeSort);
      this.data = list || [];
      this.countAvailableQuantity();
    }, 100),
    countAvailableQuantity() {
      this.setRoomData();
      let dateObj = {},
        len = this.data.length;
      this.calendarOutput.forEach(el => {
        let availableQuantity = len;
        this.data.forEach(item => {
          if (
            item.RoomStatusCalendarOutputs &&
            item.RoomStatusCalendarOutputs.length
          ) {
            item.RoomStatusCalendarOutputs.forEach(p => {
              if (
                (p.RoomStatus == 2 || p.RoomStatus == 3) &&
                moment(el.FullDate).isBetween(
                  p.RepairBeginTime,
                  p.RepairEndTime,
                  null,
                  "[)"
                )
              ) {
                availableQuantity--;
              }
              (p.CalendarGuestDetails || []).forEach(o => {
                if (
                  moment(el.FullDate).isBetween(
                    o.CheckInDate,
                    o.CheckOutDate,
                    null,
                    "[)"
                  )
                ) {
                  availableQuantity--;
                }
              });
            });
          }
        });
        if (!dateObj[el.FullDate]) {
          dateObj[el.FullDate] = {
            AvailableQuantity: availableQuantity
          };
        }
      });
      this.availableQuantityObj = dateObj;
    }
  }
};
</script>
<style lang="less" scoped>
.all-order-items {
  max-height: calc(40vh);
  overflow-y: auto;
}
</style>
